import { USIndicator } from '~/entities/reviewer'
import { useUserStore } from '~/entities/user'
import { cn } from '~/shared/lib/cn'
import { TABLE_COLUMNS_MAP } from '../../config'

export function KeyHeader() {
  const isOnshore = useUserStore((state) => state.isOnshore)

  return (
    <div
      className={cn('flex gap-2.5', {
        '-ml-3': isOnshore,
      })}
    >
      {isOnshore && <USIndicator className="invisible h-4" />}
      {TABLE_COLUMNS_MAP.key.label}
    </div>
  )
}
